import { useState } from 'react';
import Image from 'next/image';
import { CardImages } from 'matrix';
import Breadcrumbs from '@sympla/sympla-components/Breadcrumbs';
import Button from '@sympla/sympla-components/Button';
import { IconArrowDown } from '@sympla/sympla-components/NavigationIcons';
import { breadcrumbSearchBase } from 'constants/breadcrumbSearchBase';
import { DEFAULT_IMAGE } from 'constants/index';
import locationStore from 'stores/LocationStore';

import * as styles from './BannerTopicSearch.css';

function BannerTopicSearch({
  label,
  description,
  images,
  isMobile,
}: {
  label: string;
  description: string;
  images: CardImages;
  isMobile: boolean;
}) {
  const [showMoreDescription, setShowMoreDescription] = useState(isMobile);
  const getLocationLabel = () => (
    <p className={styles.SearchActionSubtitle} id="subtitle-topic">
      em
      {' '}
      {locationStore?.selectedLocation?.city}
      {' '}
      e região
    </p>
  );

  const handleMoreDescription = () => {
    setShowMoreDescription((prev) => !prev);
  };

  const getClass = () => {
    if (isMobile) {
      return showMoreDescription ? styles.SearchActionDescriptionClam : styles.SearchActionDescriptionBackground;
    }
    return '';
  };

  return (
    <div className={styles.BannerTopicSearchPosition}>
      <div className={styles.BannerContainerImage}>
        <Image
          src={images.banner || images?.lg || images?.xs || DEFAULT_IMAGE}
          className={styles.BannerImage}
          alt={`Banner de ${label}`}
          loading="eager"
          fill
          priority
          quality={75}
          sizes="(max-width: 640px) 100vw, (max-width: 1200px) 100vw, 100vw"
        />
        <div className={styles.BannerBackground} />
      </div>

      <div className={styles.BannerContainer}>
        <div className={styles.ContentBannerTopicSearch}>
          <div className={styles.BreadcrumbsBannerTopicSearch}>
            <Breadcrumbs list={breadcrumbSearchBase} />
          </div>
          <div>
            <div className={styles.BannerContentFlex}>
              <h1 className={styles.SearchActionTitle}>{label}</h1>
              <Button
                onClick={() => locationStore.setIsLocationModalVisible(true)}
                color="neutral"
                size="medium"
                icon={<IconArrowDown width={24} height={24} className={styles.BannerIcon} />}
                rounded
                aria-label="Mudar cidade"
              />
            </div>
            {locationStore?.selectedLocation?.slug && locationStore?.selectedLocation?.city !== label && getLocationLabel()}
            <div className={styles.SearchActionDescription}>
              <p className={getClass()}>{description}</p>
              {isMobile && (
                <div
                  className={styles.SearchActionMoreDescription}
                  onClick={handleMoreDescription}
                  role="button"
                  aria-expanded={showMoreDescription}
                  aria-label={`${showMoreDescription ? 'Mostrar menos' : 'Mostrar mais'} da descrição`}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleMoreDescription();
                    }
                  }}
                >
                  {showMoreDescription ? 'Mais' : 'Menos'}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerTopicSearch;
